import { PlatformApi } from '~/services/api/platform'

export class DisplayBoardService extends PlatformApi {
  async getAll() {
    return await this.get('/display-board')
  }

  async getById(paddockId) {
    return await this.get(`/display-board/${paddockId}`)
  }
}
